import { render, staticRenderFns } from "./QuestionWarehouseAdd.vue?vue&type=template&id=e70ecf92"
import script from "./QuestionWarehouseAdd.vue?vue&type=script&lang=js"
export * from "./QuestionWarehouseAdd.vue?vue&type=script&lang=js"
import style0 from "./QuestionWarehouseAdd.vue?vue&type=style&index=0&id=e70ecf92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports